module.exports = __webpack_public_path__ + "static/media/HL12.d0ddae60.jpg";